<template>
  <div class="order-card-wrapper-h5" @click="showOrderDetail">
    <div class="header-box">
      <p
        class="order-status-desc"
        :class="{'high-light': highlight(orderInfo.status)}"
        v-text="orderInfo.statusDesc"
      ></p>
      <p class="order-alert-msg" v-text="orderInfo.alertMsg"></p>
    </div>
    <div class="shop-detail-wrapper" @click.stop="goShopDetail">
      <div class="logo-img">
        <img
          v-if="shopInfo.logoImg"
          :src="shopInfo.logoImg"
          v-img-size="'mini'"
          v-http2
          v-img-error
        />
      </div>
      <div class="shop-info-box"><div class="center-box">
        <!-- 门店详情入口  -->
        <div class="shop-detail-btn">
          <p class="shop-name">{{shopInfo.shopName}}</p>
          <i class="icon-outline_entrance"></i>
        </div>
        <!-- 门店活动标签 | 非营业状态信息 无不展示但占位 -->
        <div class="tag-box" v-show="businessStatusMap.noBusiness || (shopInfo.actTips && shopInfo.actTips.length)">
          <template v-if="businessStatusMap.noBusiness">
            <p class="status-tag" v-text="businessStatusMap.statusDesc"></p>
            <p class="time-desc" v-text="businessStatusMap.timeDesc"></p>
          </template>
          <template v-else>
            <ShopTag
              v-for="(item, index) in shopInfo.actTips"
              :key="'tag' + index"
              :text="item"
            />
          </template>
        </div>
      </div></div>
    </div>
    <!-- 菜的展示 -->
    <div class="cate-wrapper">
      <CollapseWrapper
        :list="items"
        :showMinIndex="showMinIndex"
        customCollapseBoxClass="collapse-box-order-card"
      >
        <template v-slot:item="slotProps">
          <div
            class="cate-item"
          >
            <div class="left-box">
              <div class="center-box">
                <p class="cate-name" v-text="slotProps.item.itemName"></p>
                <p class="cate-options" v-if="slotProps.item.subItemDesc" v-text="slotProps.item.subItemDesc"></p>
              </div>
            </div>
            <img
              class="cate-logo"
              v-if="slotProps.item.headImg"
              :src="slotProps.item.headImg"
              v-img-size="'mini'"
              v-http2
              v-img-error
            />
          </div>
        </template>
      </CollapseWrapper>
    </div>
    <div class="bottom-box">
      <p class="order-create-time" v-text="orderInfo.createTime"></p>
      <p class="order-price" v-text="orderInfo.realPayPriceDisplay"></p>
      <!-- 评价 查看评价 dark -->
      <el-button
        v-for="(buttonMap, index) in buttons"
        :key="'button' + index"
        class="order-btn"
        :dark="!buttonMap.highlight"
        outline
        v-text="buttonMap.name"
        @click.stop="btnClick(buttonMap.type)"
      ></el-button>
    </div>
  </div>
</template>
<script>
import mixin from './mixin.js'
import ShopTag from '@/components/ShopCard/tag.vue'
import CollapseWrapper from '@/components/CollapseWrapper'

export default {
  name: 'OrderMbCard',
  components: {
    ShopTag,
    CollapseWrapper,
  },
  props: {
    info: Object,
  },
  mixins: [mixin],
  data() {
    return {
      showMinIndex: 2,
      shopInfo: {},
      orderInfo: {},
      items: {},
      buttons: {},
      starList: [{}, {}, {}, {}, {}],
      businessStatusMap: {
        noBusiness: false,
        timeDesc: '',
        statusDesc: '',
      }
    }
  },
  created() {
    this.init(this.info)
    this.computedBusinessStatus(+this.shopInfo.cShopStatus, this.shopInfo.nextBizTimeDesc)
  },
  methods: {
    init(nVal) {
      this.shopInfo = nVal?.shopInfo
      this.orderInfo = nVal?.orderInfo
      this.items = nVal?.itemInfo?.items
      this.buttons = nVal?.buttons.filter(item => +item.type !== 2) || []
    },
  }
}
</script>
<style lang="scss">
.order-card-wrapper-h5 .collapse-box-order-card {
  margin: rem(16) 0 rem(8);
  height: rem(36);
  font-family: 'Aspira Light';
  font-size: rem(28);
  color: #666666;
  cursor: pointer;
}
</style>
<style lang="scss" scoped>
.order-card-wrapper-h5 {
  padding: rem(40) rem(18);
  background: #FFFFFF;
  border-radius: rem(12);
}
.header-box {
  height: rem(36);
  line-height: rem(36);
  overflow: hidden;
}
.order-status-desc {
  float: left;
  font-family: 'Aspira Medium';
  font-size: rem(36);
  color: #000000;
  font-weight: 500;
}
.high-light {
  @include font-color()
}
.order-alert-msg {
  margin-left: rem(12);
  float: left;
  font-family: 'Aspira Light';
  font-size: rem(28);
  color: #666666;
}
// content

.shop-detail-wrapper {
  display: flex;
  margin: rem(32) 0 rem(24);
  overflow: hidden;
}

.logo-img {
  margin-right: rem(16);
  align-self: center;
  font-size: 0;
  overflow: hidden;
}
.logo-img img {
  display: inline-block;
  vertical-align: middle;
  width: rem(80);
  height: rem(80);
  object-fit: cover;
  background: rgba(255,255,255,0.00);
  border-radius: rem(8);
  border: 1px solid #DBDBDB;
}

.shop-info-box {
  width: rem(520);
}
.shop-info-box .center-box {
  display: inline-block;
  width: 100%;
  vertical-align: middle;
}
.shop-detail-btn {
  position: relative;
  cursor: pointer;
  font-size: 0;
}
.shop-detail-btn i {
  display: inline-block;
  font-size: rem(28);
  background: #fff;
  vertical-align: middle;
}
.shop-name {
  display: inline-block;
  max-width: calc(100% - 20px);
  line-height: rem(32);
  font-family: 'Aspira Light';
  font-size: rem(32);
  color: #000000;
  font-weight: 500;
  word-break: break-all;
  word-wrap: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
.tag-box {
  margin: rem(10) 0 0;
  max-width: rem(520);
  font-size: 0;
  white-space: normal;
  overflow : hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.time-desc {
  display: inline-block;
  height: rem(42);
  line-height: rem(42);
  font-size: rem(24);
  font-family: 'Aspira Light';
  color: #000000;
}
.status-tag {
  display: inline-block;
  margin-right: rem(16);
  padding: rem(10) rem(16);
  height: rem(42);
  font-size: rem(22);
  font-family: 'Aspira Medium';
  font-weight: 500;
  color: #000000;
  border-radius: rem(4);
  background: #E5E5E5;

}

.cate-wrapper {
  padding: rem(10) rem(18);
  width: 100%;
  background: #F8F8F8;
  border-radius: rem(8);
}
.cate-item {
  display: flex;
  position: relative;
  padding: rem(8) 0;
  overflow: hidden;
}
// .cate-item:last-child {
//   margin-bottom: 0;
// }
.left-box {
  flex: 1;
  margin: rem(2) 0;
  width: rem(500);
}
.center-box {
  display: inline-block;
  vertical-align: middle;
}
.cate-name {
  height: rem(44);
  line-height: rem(44);
  font-family: 'Aspira Medium';
  font-size: rem(32);
  font-weight: 500;
}
.cate-options {
  height: rem(40);
  line-height: rem(40);
  font-family: 'Aspira Light';
  font-size: rem(28);
}
.cate-name,
.cate-options {
  width: rem(500);
  color: #000000;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
  word-wrap: break-word;
}
.cate-logo {
  width: rem(88);
  height: rem(88);
  object-fit: cover;
  background: rgba(255,255,255,0.00);
  border-radius: rem(8);
}

// bottom
.bottom-box {
  margin-top: rem(32);
  text-align: right
}

.order-create-time {
  float: left;
  height: rem(36);
  line-height: rem(36);
  font-family: 'Aspira Light';
  font-size: rem(28);
  color: #999999
}
.order-price {
  height: rem(36);
  line-height: rem(36);
  font-family: 'Aspira Medium';
  font-size: rem(36);
  color: #000000;
  text-align: right;
  font-weight: 500;
}
.order-btn {
  display: inline-block;
  margin-top: rem(32);
  min-width: rem(262);
  height: rem(64);
  border-radius: rem(8);
}
</style>